/**Componentes React */
import { useEffect, useState } from 'react';

/**Librerías de terceros */
import { Col, Container, Row, Image } from 'react-bootstrap';

/**Archivos de configuración */
import { IStoreJsonConfiguration } from '@/domain/interfaces/IStoreJsonConfiguration';
import { store } from '@/data/libraries/Store';

/** Controladores */
import StoreJSONController from '@/controllers/StoreJSONController';
import BranchOfficesController from '@/controllers/BranchOfficesController';

/**Interfaces  declaradas como tipos */
import { type IBranchOffice } from '@/domain/interfaces/IBranchOffice';

/**Redux & CustomHooks */
import { ScreenSize, useScreenSize } from '@/ui/hooks/useScreenSize';

/**Utilidades */
import { translate } from '@/domain/utils/translate';


/**Assets */
import BlankImageBanner from '@/ui/assets/BlankImageBanner';

/**Componentes */
import Carousel from '@/ui/components/Carousel';
import ContactInformation from '@/ui/components/store/ContactInformation';


/**
 * Componente `StoreInfo` que representa el detalle de la tienda.
 * 
 */
const StoreInfo = () => {

    /** Hook que contiene las dimensiones de la pantalla y maneja los componentes de acuerdo al resultado obtenido */
    const { width, maxLargeWidth }: ScreenSize = useScreenSize();

    /** Variable que define si es entorno mobile o desktop */
    const isMobile: boolean = width < maxLargeWidth;
    /** estado de imágenes del slider */
    const [images, setImages] = useState<string[]>([]);

    /** Controlador funciones del Index */
    const { getStoreJsonConfiguration } = StoreJSONController();
    const getStoreConfiguration = async () => {
        try {
            const data: IStoreJsonConfiguration | null = await getStoreJsonConfiguration();
            if (data) {


                setImages(isMobile ? data.storeInfoMobileImagesSlider : data.storeInfoDesktopImagesSlider);
            }
        } catch (error) {
            console.error(error);
        }
    };

    /** Valor del ID de la tienda */
    const storeId: number = store.DEFAULT;

    /** Controlador de sucursales */
    const { getBranchOffices } = BranchOfficesController();

    /** Estado para almacenar las sucursales */
    const [branchOffices, setBranchOffices] = useState<IBranchOffice[]>([]);

    /** Carga las sucursales al montar el componente */
    useEffect(() => {
        const loadBranchOffices = async () => {
            const offices = await getBranchOffices(storeId);
            setBranchOffices(offices);
        };
        loadBranchOffices();
    }, [storeId]);

    ///useEffect que trae las secciones y redes sociales y carruseles de imágenes a traves del controlador
    useEffect(() => {
        getStoreConfiguration();
    }, []);

    // Desplazar al inicio de la página al montar el componente
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const STORE_INFO_TITLE: string = translate('store.store_info_title');
    const STORE_INFO_CONTENT: string = translate('store.store_info_content');


    return (

        <Container className='px-0 pt-0 pb-3 bg-secondary-5' fluid>
            <Container className='py-3 px-1'>

                <Row className='g-0'>
                    <Col xs={isMobile ? 12 : 6}>
                        <Row className='mx-2 mt-3'>
                            <Col xs={12} className={`${isMobile ? 'text-center' : ''}`}>
                                <span className={`${isMobile ? 'h3' : 'h2'} fw-bold `} >{STORE_INFO_TITLE}</span>

                            </Col>
                            <Col xs={12} className='my-4'>
                                <span className={`${isMobile ? 'paragraph' : 'h5'} fw-bold `}>{STORE_INFO_CONTENT}</span>
                            </Col>
                            <Row className='g-0'>
                                <Col className={`${isMobile ? 'px-3 py-0' : 'mt-1 pt-3 ps-3'} d-flex flex-column h-100 justify-content-between`}>
                                    <ContactInformation customColor='primary-1' />
                                </Col>
                            </Row>
                        </Row>
                    </Col>
                    <Col xs={isMobile ? 12 : 6}>
                        <Row className='mx-2 mt-3 g-0'>
                            <Col xs={12} className={`h-100 p-0`}>
                                <iframe
                                    src={branchOffices[0]?.contact.googleMapsUrl}
                                    width={`${isMobile ? '324' : '600'}`}
                                    height={`${isMobile ? '324' : '600'}`}
                                    style={{ border: 0 }}
                                    loading="lazy"
                                    className='rounded shadow w-100'
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Google Maps Embed"
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container >
            <Col xs={12}>
                {/* Carousel de Imágenes */}
                <Row className='mb-4 mb-lg-0 g-0 full-centered-carousel '>
                    <Carousel
                        slidesToShow={1}
                        slidesToScroll={1}
                        centerPadding={'0px'}
                        speed={500}
                        autoplay={true}
                        autoplaySpeed={5000}
                        centerMode={true}
                        arrows={!isMobile}>
                        {images?.map((image, index) => (
                            <Col key={`store-info-image-${index}`} >
                                <Image
                                    fluid
                                    src={image}
                                    alt={`Image ${index}`}
                                    className='cursor-hand w-100'
                                    onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                                        e.currentTarget.src = BlankImageBanner;
                                    }}
                                />
                            </Col>
                        ))}
                    </Carousel>
                </Row>
            </Col>
        </Container >

    );
}

export default StoreInfo